import React, { useEffect, useState } from 'react';
import Layout from '../../containers/Layout';
import Button from '../../components/Button';
import { useHistory, useParams } from 'react-router-dom';
import { Order } from '../../requests/caipirinha-api/interfaces/order.interface';
import CaipirinhaRequest from '../../requests/caipirinha-api/caipirinha.request';
import { Card, ContainerTerm, DownloadButton, Icon, ContainerTitle } from './styles';
import IconDownload from '../../assets/icons/ic_download.svg';
import Error from './helpers/error';
import { Buffer } from 'buffer';
import { removeSignatureFields } from './helpers/removeSignatureFields';
import { generatePdf } from './helpers/generatePdf';
import { formatTac3pToHtml } from './helpers/formatTac3pToHtml';
import { replaceParameters } from './helpers/replaceParameters';
import Title from '../../components/Title';
import { authorizarionTermType } from '../../constants/authorizationTermType.enum';

type UrlParams = {
  id: string;
  document: string;
  serviceId: string;
};

type HistoryState = {
  order?: Order;
  description?: string;
};

export default function AuthorizationTerm() {
  const { replace, location } = useHistory<HistoryState | undefined>();

  const [authorizarionTerm, setAuthorizarionTerm] = useState<string>();
  const [hasError, setHasError] = useState(false);
  const [loading, setLoading] = useState(true);
  const [is3p, setIs3p] = useState(false);
  const { id, serviceId } = useParams<UrlParams>();

  const order = location.state?.order;
  const serviceName = location.state?.description;

  const GoBackButton = () => {
    return (
      <Button
        data-cy='go-back-button'
        onClick={() => order && replace(`/${id}`, { order })}>
        Voltar
      </Button>
    );
  };

  const handleDownloadTerm = () => {
    generatePdf({
      htmlString: authorizarionTerm || '',
      fileName: serviceName,
    });
  };

  useEffect(() => {
    CaipirinhaRequest.getAuthorizationTerm(id, serviceId)
      .then((data) => {
        let html = Buffer.from(data.base64, 'base64').toString('utf-8');
        const isMarketplace = data.type === authorizarionTermType.MARKETPLACE;
        setIs3p(isMarketplace);

        if (isMarketplace) {
          html = formatTac3pToHtml(html);
          html = replaceParameters(html, data.service);
        } else {
          html = removeSignatureFields(html);
        }

        setAuthorizarionTerm(html);
      })
      .catch(() => setHasError(true))
      .finally(() => setLoading(false));
  }, []);

  return (
    <Layout overContent={<GoBackButton />} title='' loading={loading} dark>
      {!hasError ? (
        <>
          <ContainerTitle>
            <Title data-cy='page-title'>{serviceName}</Title>
            <DownloadButton onClick={handleDownloadTerm} data-cy='download-button'>
              <Icon src={IconDownload} />
            </DownloadButton>
          </ContainerTitle>
          <Card>
            <ContainerTerm
              is3p={is3p}
              dangerouslySetInnerHTML={{ __html: authorizarionTerm || '' }} />
          </Card>
        </>
      ) : (
        <Error />
      )}
    </Layout>
  );
};
